export { default as ShippingQuery } from './ShippingQuery';